import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'success' | 'warning';
  size?: 'sm' | 'md' | 'lg' | 'icon';
  isLoading?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-accent-500 text-white hover:bg-accent-600 shadow-sm',
    secondary: 'bg-brand-500 text-white hover:bg-brand-600',
    outline: 'border border-slate-200 bg-transparent hover:bg-slate-50 text-black',
    ghost: 'hover:bg-slate-100 text-black',
    danger: 'bg-rose-600 text-white hover:bg-rose-700 shadow-sm',
    success: 'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm',
    warning: 'bg-accent-500 text-white hover:bg-accent-600 shadow-sm'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-8 text-lg',
    icon: 'h-10 w-10 p-2 flex items-center justify-center'
  };
  return <button className={cn('inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], className)} disabled={disabled || isLoading} {...props} data-id="element-141">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-142" />}
      {children}
    </button>;
}